// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"86d9e289219514246df9","532":"85442663a532924544e0","691":"4bb998622818cb739559"}[chunkId] + ".js";
};